import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';


@Component({
  selector: 'q-qualiopi-picto',
  templateUrl: './qualiopi-picto.component.html',
  styleUrls: ['./qualiopi-picto.component.css']
})
export class QualiopiPictoComponent implements OnInit {
  // #region Variable globale

  public SelectedIcon: string;

  // #endregion

  @Input('iconQualiopi') set SetIcon(value: string) {
    this.SelectedIcon = value;
  }

  @Output() EmitIcon: EventEmitter<string> = new EventEmitter<string>();
  // #region constructor
  constructor(

  ) { }

  // #endregion

  ngOnInit(): void {

  }

  // #region Fonctions public

  SelectIcon(icone: string) {
    this.EmitIcon.emit(icone);
  }

  // #endregion

  // #region Fonctions private

  // #endregion

}




